import store from "@/store/store";

export default function(id) {
  if(!store.state.user.employees) return "-";
  const user = store.state.user.employees[id];
  return `${user.firstName} ${user.lastName}`;
}
